module.exports = __webpack_public_path__ + "media/gocd_logo-8fa5e40804bf03dd2ccf014df1c24311.svg";